import React from 'react';
import classnames from 'classnames';
import Label from 'components/shared/Label';
import './CustomInputField.css';

function CustomInputField({ name, label, placeholder, value = '', errorMessage, disabled, onChange, setErrors }) {
  const isDelta = name.split('_').includes('delta');

  const handlerChange = (e) => {
    if (onChange) {
      onChange(e);
    }

    if (setErrors) {
      setErrors((state) => ({ ...state, [name]: undefined }));
    }
  };

  return (
    <div className="CustomInputField_Wrapper" data-testid='CustomInputField_Wrapper'>
      <Label name={name} text={label} />

      <input
        type="text"
        className={classnames({
          CustomInputField: true,
          InputField_Custom_Disabled: disabled,
          InputField_Custom_Disabled_With_Value: disabled && (value !== null || value !== undefined),
          InputField_Custom: true,
          InputField_Error: errorMessage
        })}
        autoComplete="off"
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={handlerChange}
        disabled={disabled}
      />

      {errorMessage && (
        <span
          className={classnames({
            CustomInputField_ErrorMessage: !isDelta,
            CustomInputField_ErrorMessage_Delta: isDelta,
            InputField_Custom_ErrorMessage: true
          })}
        >
          {errorMessage}
        </span>
      )}
    </div>
  );
}

export default CustomInputField;
